export default "__VITE_ASSET__BHFXwdCb__"